import React, { PropsWithChildren } from 'react';
import {createStyles, makeStyles, Theme, useTheme} from '@material-ui/core/styles';
import {Box, Typography} from "@material-ui/core";
import {Link} from 'react-router-dom';
import {HOME_OVERVIEW_PAGE_PATH} from "../navigation/Navigator";

const useStyles = makeStyles((theme: Theme) => createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            marginBottom: 10
        },
        logoRoot: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        sidebarIcon: {
            marginRight: 10,
            position: "fixed",
            right: 0,
            zIndex: 999,
            "& .MuiIconButton-edgeEnd": {
                margin: 0
            }
        },
        logo: {
            height: 80
        },
        titleBar: {
            color: "#fff",
            backgroundColor: theme.palette.primary.main
        },
        titleText: {
            marginLeft: 10
        }
    }
));

type PageHeaderProps = {
    pageTitle?: string
};

const PageHeader: React.FC<PropsWithChildren<PageHeaderProps>> = ({pageTitle, children}) => {
    const classes = useStyles({});
    const theme = useTheme();

    return (
        <div className={classes.root}>
            <div className={classes.logoRoot}>
                <Link to={HOME_OVERVIEW_PAGE_PATH}>
                    <img src={theme.domainLogo.url} className={classes.logo} alt={"logo"}/>
                </Link>
                {children && <div className={classes.sidebarIcon}>
                    {children}
                </div>
                }
            </div>
            {pageTitle &&
            <Box component="div" className={classes.titleBar}>
                <Typography variant="subtitle2" className={classes.titleText}>{pageTitle}</Typography>
            </Box>
            }
        </div>
    );
};

export default PageHeader;